// Accordion.js
import React, { useEffect, useState } from "react";
import "./Accordian.css";
import drop from "../../../../../../../../assets/arrow_drop_down (1).svg"
import PassengerService from "../../../../../../../../services/passenger/passenger.service";
import { useParams } from "react-router-dom";

const Accordion = ({ title, questionId }) => {
  const { passengerId } = useParams();
  const [isActive, setIsActive] = useState(false);
  const [allAnswere, setAllAnswere] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        let specificQuestionAnswere = await PassengerService.getAnswereById(passengerId, questionId);
        console.log("specificQuestionAnswere", specificQuestionAnswere);
        // Grouping records by month and year
        const groupedRecords = {};
          specificQuestionAnswere.forEach(record => {
            const yearMonth = getMainDate(record.timestamp);
            if (!groupedRecords[yearMonth]) {
              groupedRecords[yearMonth] = [];
            }
            groupedRecords[yearMonth].push(record);
          });

        const result = Object.keys(groupedRecords).map(key => ({
          month: key,
          records: groupedRecords[key]
        }));
        console.log("groupedRecords", result);
        setAllAnswere(result);
      } catch (error) {
        console.log(error);
      }
    })();
  },[]);

  const getMainDate = (time) => {
    const date = new Date(time);
  // Get the month name and year
  const monthName = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();

  const formattedDate = `${monthName}, ${year}`;

  return formattedDate;
  }

  const getFomttedDateTime = (time) => {
    const date = new Date(time);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

  const timeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };
  const Ftime = date.toLocaleString('default', timeOptions);

  const formattedDate = `${day} ${month}, ${Ftime}`;

  return formattedDate;
  }
  let answereHistory;
  if (allAnswere.length > 0) {
    answereHistory = allAnswere.map((answere, index) => {
        return (
          <div className="accordion-item" style={{borderBottom: isActive ? "none" : "0.5px solid #E9F2FF"}}>
            {
              index == 0 &&
              <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
              <div className="queestion-answere-container">
                  <div className="medical-question">{title}</div>
                  <div className="answere">{answere.records[0].answer || "No"}</div>
              </div>
              <div><img src={drop} alt="Accordian open" className={isActive ? "accodian-controller-icon open" : "accodian-controller-icon"} /></div>
            </div>
            }
          {isActive && <div className="accordion-content">
            <div key={answere.id} style={{marginTop: index != 0 ? 10 : 0}}>
            <h3>{answere.month}</h3>
            {
              answere.records.map((monthUpdation, index2) => {
                return (
                    <div className={index2 != 0 ? `accordian-content-container` : `accordian-content-container first-accordian-container`}>
                        <div className="left">
                            <div className="timeline-shape"></div>
                        </div>
                        <div className="right">
                            <h3>
                              <span>{monthUpdation?.answer || ""}</span>
                            </h3>
                            <p>{getFomttedDateTime(monthUpdation.timestamp)}</p>
                        </div>
                    </div>
                )
              })
            }
          </div>
          </div>}
        </div>
        )
      });
    } else {
      answereHistory = <div className="accordion-item" style={{borderBottom: isActive ? "none" : "0.5px solid #E9F2FF"}}>
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div className="queestion-answere-container">
            <div className="medical-question">{title}</div>
            <div className="answere">No</div>
        </div>
        <div><img src={drop} alt="Accordian open" className={isActive ? "accodian-controller-icon open" : "accodian-controller-icon"} /></div>
      </div>
      {isActive && <div className="accordion-content">
        <span className="no-history">No Previous Medical History</span>
      </div>}
    </div>
    }

  return answereHistory
};

export default Accordion;
